import { styled } from '@ori-ui/mui';

import { SEARCH_PREVIEW_SEE_ALL_HEIGHT } from '../../constants';
import { SeeAllResults } from '../SearchPreview/styles';
import { UnifiedSkeleton } from '../styles';

export const HeaderSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  width: 150,
  minHeight: 28,
  [theme.breakpoints.up('md')]: {
    minHeight: 33,
    width: 200,
  },
}));

export const SeeAllSkeleton = styled(SeeAllResults)(({ theme }) => ({
  height: SEARCH_PREVIEW_SEE_ALL_HEIGHT,
}));
